import React from 'react';

import { UpgradeModalProvider } from '@zapier/upsells/src/contexts';
import { useUpgradeModal } from './useUpgradeModal';

import {
  UpgradeModalLayout,
  UpgradeModalLayoutProps,
} from './UpgradeModalLayout';

/**
 * A testing guide for this component can be found in Coda:
 * https://coda.io/d/Revenue-Growth_d_s-Io-GBfk/Testing-the-Upgrade-Modal_su1QB#_lukP1
 */
export const UpgradeModal = ({
  appName,
  onClose,
  onUpgradeFinish = () => {},
  shouldAutoUpgrade = true,
  upgradeReason,
  wasTriggeredByZapToggle = false,
}: UpgradeModalLayoutProps) => {
  const upgradeModalData = useUpgradeModal({
    shouldAutoUpgrade,
    upgradeReason,
  });

  return (
    <UpgradeModalProvider upgradeModalData={upgradeModalData}>
      <UpgradeModalLayout
        appName={appName}
        onClose={onClose}
        onUpgradeFinish={onUpgradeFinish}
        shouldAutoUpgrade={shouldAutoUpgrade}
        upgradeReason={upgradeReason}
        wasTriggeredByZapToggle={wasTriggeredByZapToggle}
      />
    </UpgradeModalProvider>
  );
};
